export interface PriceTypeLabel {
  readonly label: string
  readonly longLabel: string
}

export const PriceTypeRetail: PriceTypeLabel = {
  label: 'Retail',
  longLabel: 'RRP (Inc. GST)',
}
